module.exports = __webpack_public_path__ + "static/img/logo-pj-transparente-negro.d628a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pj-transparente-negro.png
// module id = 72nI
// module chunks = 2